import * as React from 'react';
export const atlanticunionSvg = React.forwardRef(function atlanticunionSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1C4FB2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 26.03c3.077-7.36 6.134-14.67 9.22-22.03.078.145.117.212.146.28.974 2.286 1.958 4.572 2.922 6.857a.826.826 0 0 1 0 .608c-1.939 4.659-3.887 9.308-5.826 13.967-.106.25-.231.328-.501.328-1.862-.01-3.723 0-5.594 0H8v-.01Zm8.19 0c1.735-4.148 3.442-8.228 5.179-12.385.289.656.54 1.225.8 1.804.8 1.813 1.601 3.617 2.383 5.44a.69.69 0 0 1 .01.482c-.59 1.447-1.206 2.875-1.795 4.321-.106.26-.24.348-.52.348-1.891-.01-3.791 0-5.691 0h-.377l.01-.01Z',
      fill: '#06A04A',
    }),
  );
});
atlanticunionSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var atlanticunion = {
  category: 'brand',
  colorable: false,
  name: 'atlanticunion',
  svg: atlanticunionSvg,
};
